import validate from "validate.js";
import { dateFormat, Validator, presence, format, regExpInvalidCharPattern, maxLength, ValidationField } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
import { isNullOrUndefined, MypageMessageFormat } from "~/extensions/utils/DefineFunction";
import dayjs from "dayjs";
export class TaikyoEntryPageValidator extends Validator {
    constructor(vm, taikyoForInput) {
        const constraints = {
            sonotaKeiyaku: {
                sonotaKeiyakuFormatKojin: sonotaKeiyakuFormatKojin(vm),
                sonotaKeiyakuMaxLengthKojin: sonotaKeiyakuMaxLengthKojin(vm, 100)
            },
            tel: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: new RegExp("^(060|070|080|090)-?\\d{4}-?\\d{4}$"), message: commonStore.messages.PV0012 })
            },
            taikyoYmd: {
                presence: presence(false, commonStore.messages.PV0001),
                dateFormat: dateFormat(commonStore.messages.PV0005),
                isValidateKojin: isValidateKojin(vm, commonStore.messages.PV0027, commonStore.messages.PV0031, commonStore.messages.PV0015, taikyoForInput)
            },
            taikyoRiyuKb: {
                presence: presence(false, commonStore.messages.PV0002)
            },
            taikyoRiyu: {
                taikyoRiyuPresenceKojin: taikyoRiyuPresenceKojin(vm, commonStore.messages.PV0001),
                taikyoRiyuMaxLengthKojin: taikyoRiyuMaxLengthKojin(vm, 100)
            },
            postCode: {
                format: format({ pattern: new RegExp("^[0-9]{3}-?[0-9]{4}$"), message: commonStore.messages.PV0014 })
            },
            adr1: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            adr2: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            adr3: {
                format: regExpInvalidCharPattern,
                length: maxLength(20)
            },
            movingServices: {
                movingServicesPresence: movingServicesPresence(vm, commonStore.messages.PV0002)
            }
        };
        super(vm.model, constraints);
        this.sonotaKeiyaku = new ValidationField("sonotaKeiyaku", this.data, constraints);
        this.tel = new ValidationField("tel", this.data, constraints);
        this.taikyoYmd = new ValidationField("taikyoYmd", this.data, constraints);
        this.taikyoRiyuKb = new ValidationField("taikyoRiyuKb", this.data, constraints);
        this.taikyoRiyu = new ValidationField("taikyoRiyu", this.data, constraints);
        this.postCode = new ValidationField("postCode", this.data, constraints);
        this.adr1 = new ValidationField("adr1", this.data, constraints);
        this.adr2 = new ValidationField("adr2", this.data, constraints);
        this.adr3 = new ValidationField("adr3", this.data, constraints);
        this.movingServices = new ValidationField("movingServices", this.data, constraints);
    }
    sonotaKeiyaku;
    tel;
    taikyoRiyuKb;
    taikyoRiyu;
    taikyoYmd;
    postCode;
    adr1;
    adr2;
    adr3;
    movingServices;
}
/** その他契約が表示されているときだけformatチェック */
validate.validators.sonotaKeiyakuFormatKojin = function (value, options, key, attributes) {
    if (!options.vm.isParkingContract) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function sonotaKeiyakuFormatKojin(vm) {
    return {
        vm: vm
    };
}
/** その他ご契約事項が表示されているときだけ最大文字数チェック */
validate.validators.sonotaKeiyakuMaxLengthKojin = function (value, options, key, attributes) {
    if (!options.vm.isParkingContract) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function sonotaKeiyakuMaxLengthKojin(vm, maximum) {
    return {
        maximum: maximum,
        vm: vm
    };
}
/** 退去予定日 過日/超過チェック  */
validate.validators.isValidateKojin = function (value, options, key, attributes) {
    const min = !isNullOrUndefined(options.forInput.taikyoDateMinDays) ? options.forInput.taikyoDateMinDays : 0;
    const max = options.forInput.taikyoDateMaxDays;
    const maxDate = options.forInput.taikyoMaxDate;
    if (typeof value === "undefined" || value === null || value === "") {
        return MypageMessageFormat(options.messageToday, { val: options.context });
    }
    let taikyoYmd = dayjs(value);
    let today = dayjs().startOf("day");
    if (!taikyoYmd.isValid()) {
        if (min !== 0) {
            return MypageMessageFormat(options.messageMin, { val: min });
        }
        return MypageMessageFormat(options.messageToday, { val: null });
    }
    // 本日から退去予定日までの日数が最大日数を超える場合
    let daysUntilTaikyo = taikyoYmd.diff(today, "day", true);
    if (daysUntilTaikyo > max) {
        const daysUntilMaxDate = dayjs(maxDate).diff(today, "day", true);
        // 以下の条件を満たす場合、最大日付（汎用区分：4、汎用マスタ.オプション3）のエラーメッセージを表示
        // 最大日付が設定されている（NULL以外）
        // 最大日付が未来日
        // 本日から最大日付までの日数が最大日数を超える
        if (!isNullOrUndefined(maxDate) && !today.isAfter(dayjs(maxDate)) && daysUntilMaxDate > max) {
            // 退去予定日が最大日付を超える
            if (taikyoYmd.isAfter(dayjs(maxDate))) {
                // const maxDate = dayjs(options.maxDate).format("YYYY年MM月DD");
                // return MypageMessageFormat(options.messageMax, { val: maxDate });
                return MypageMessageFormat(options.messageMax, { val: max });
            }
            // 退去予定日が最大日付を超えなかった場合、エラーを表示しない
            return null;
        }
        // それ以外
        return MypageMessageFormat(options.messageMax, { val: max });
    }
    // 退去予定日が本日から最低日数を超えていない場合。
    if (taikyoYmd.isBefore(today.add(min, "day"))) {
        if (min !== 0) {
            return MypageMessageFormat(options.messageMin, { val: min });
        }
        return MypageMessageFormat(options.messageToday, { val: null });
    }
    return null;
};
export function isValidateKojin(vm, messageToday, messageMin, messageMax, forInput) {
    return {
        vm: vm,
        messageToday: messageToday,
        messageMin: messageMin,
        messageMax: messageMax,
        forInput: forInput
    };
}
/** 退去理由その他が活性状態の場合にのみ必須チェック */
validate.validators.taikyoRiyuPresenceKojin = function (value, options, key, attributes) {
    // 退去理由その他が活性状態の場合にのみバリデーション
    if (!options.vm.isDisableTaikyoRiyu) {
        return validate.validators.presence(value, { allowEmpty: false, message: options.message }); // 組み込みのpresence
    }
    return null;
};
export function taikyoRiyuPresenceKojin(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** 退去理由その他が活性状態の場合にのみ最大文字数チェック */
validate.validators.taikyoRiyuMaxLengthKojin = function (value, options, key, attributes) {
    // 退去理由その他が活性状態の場合にのみバリデーション
    if (!options.vm.isDisableTaikyoRiyu) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function taikyoRiyuMaxLengthKojin(vm, maximum) {
    return {
        vm: vm,
        maximum: maximum
    };
}
/** 退引越し関連業務が活性状態の場合にのみ最大文字数チェック */
validate.validators.movingServicesPresence = function (value, options, key, attributes) {
    // 退引越し関連業務が活性状態の場合にのみバリデーション
    if (!options.vm.isParkingContract) {
        return validate.validators.presence(value, { allowEmpty: false, message: options.message }); // 組み込みのpresence
    }
    return null;
};
export function movingServicesPresence(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
